var ColumnQuery = /** @class */ (function () {
    function ColumnQuery(page, sort, filter, versionId) {
        this.page = page;
        this.sort = sort;
        this.filter = filter;
        this.versionId = versionId;
    }
    Object.defineProperty(ColumnQuery.prototype, "searchParams", {
        get: function () {
            var searchParams = new URLSearchParams([
                ['page', String(this.page)],
                ['perPage', String('100')],
                ['sort', String(this.sort)],
            ]);
            if (this.filter !== '') {
                searchParams.append('filter', String(this.filter));
            }
            if (this.versionId !== null) {
                searchParams.append('filter', String(this.filter));
            }
            return searchParams;
        },
        enumerable: false,
        configurable: true
    });
    return ColumnQuery;
}());
export { ColumnQuery };
